
























































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ISignUpFields, ICognitoSignUpFields } from '@/common/types';

// components
import Base from '@/components/Login/Base.vue';
import Welcome from '@/components/Global/Welcome.vue';
import Validation from '@/components/Form/Validation.vue';
import TextField from '@/components/Form/TextField.vue';
import Alert from '@/components/Global/Alert.vue';
import SelectField from '@/components/Form/SelectField.vue';
import RadioField from '@/components/Form/RadioField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
// Services
import router from '../../router';
import Brand from '@/services/Brand';
import store from '@/store';
import AuthService from '@/services/Auth';
import jQuery from 'jquery';
// validations
import { required, email, sameAs, minLength, numeric, requiredIf } from 'vuelidate/lib/validators';
import { helpers } from 'vuelidate/lib/validators';
import { hasUppercase, hasLowercase, hasNumber, hasSpecialCharacter } from '@/validations';
import ProgressTrackerDesktop from './ProgressTracker.vue';
import Loading from '@/components/Global/Loading.vue';
import PermissionsMessage from './PermissionsMessage.vue';
import Staff, { Invite } from '@/services/Staff';
const phoneNumReq = helpers.regex('pwdReq', /^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/);
import { Getter, Action } from 'vuex-class';
import { IUserCapabilities } from '@/common/Auth';

interface AccountSetupForm {
	given_name: string;
	family_name: string;
	email: string;
	confirm_email: string;
	password: string;
	confirmPassword: string;
	phone_number: string;
	mfaPreference: string;
	mobile_num?: string;
	policyNum?: string;
	regKey?: string;
}

@Component({
	components: {
		TextField,
		Alert,
		Validation,
		SelectField,
		RadioField,
		Base,
		Welcome,
		Checkbox,
		ProgressTrackerDesktop,
		Loading,
		PermissionsMessage,
	},
	validations: {
		form: {
			given_name: {
				required,
			},
			family_name: {
				required,
			},
			email: {
				email,
				required,
			},
			confirm_email: {
				email,
				required,
				sameAsEmail: sameAs('email'),
			},
			password: {
				required,
				minLength: minLength(10),
				hasUppercase,
				hasLowercase,
				hasNumber,
				hasSpecialCharacter,
			},
			confirmPassword: {
				required,
				sameAsPassword: sameAs('password'),
			},

			phone_number: {
				required,

				phoneNumReq,
			},
			mobile_num: {
				requiredIf: requiredIf(vm => vm.mfaPreference === 'sms'),

				phoneNumReq,
			},
			mfaPreference: { required },
		},
	},
})
export default class AccountSetup extends Vue {
	@Getter('permissions', { namespace: 'Registration' }) private permissions: {
		[key: string]: string;
	};
	@Getter('policyNum', { namespace: 'Registration' }) private policyNum: string;
	@Getter('clientId', { namespace: 'Registration' }) private clientId: string;
	@Getter('riskResourcesRequested', { namespace: 'Registration' })
	private riskResourcesRequested: boolean;

	@Action('setupPolicyNum', { namespace: 'Registration' }) private setupPolicyNum: (
		param: string,
	) => void;
	@Action('setupPermissions', { namespace: 'Registration' }) private setupPermissions: (
		param: Partial<IUserCapabilities>,
	) => void;
	@Action('setupClientId', { namespace: 'Registration' }) private setupClientId: (
		param: string,
	) => void;

	private Brand: typeof Brand = Brand;
	private error: string = '';
	private logger: any = {};
	private loading: boolean = false;
	private form: AccountSetupForm = {
		given_name: '',
		family_name: '',
		email: '',
		confirm_email: '',
		password: '',
		confirmPassword: '',
		phone_number: '',
		mfaPreference: '',
		mobile_num: '',
	};
	private isAgentBroker: boolean = false;
	private accountAlreadyExists: boolean = false;

	private isUserInvited: boolean = false;
	private invite?: Invite;

	private showPasswordRequirements() {
		jQuery('.password-requirement').addClass('password-requirement-show');
	}

	private isInValid() {
		return this.$v.$invalid;
	}

	private async created() {
		if (this.$route.query.inviteId) {
			this.loading = true;
			const inviteId: string = Array.isArray(this.$route.query.inviteId)
				? this.$route.query.inviteId[0]
				: this.$route.query.inviteId;
			this.invite = await Staff.getInviteByInviteId(inviteId);
			if (this.invite) {
				if (this.invite?.invitee_permissions) {
					this.setupPermissions(this.invite.invitee_permissions);
				}

				if (this.invite?.client_id) {
					this.setupClientId(this.invite.client_id.trim());
				}

				if (this.invite?.policy_number) {
					this.setupPolicyNum(this.invite.policy_number.trim());
				}

				this.isUserInvited = true;
				if (this.invite?.email) {
					this.form.email = this.invite.email;
					this.form.confirm_email = this.invite.email;
				}

				if (this.invite?.name) {
					const nameParts: string[] = this.invite.name.split(' ');
					this.form.given_name = nameParts[0];
					this.form.family_name = nameParts[1];
				}

				// @ts-ignore
				this.$route.params.quickQuestions = true;
			}
		}

		/**
		 * If we don't have this set to true, we need to send them back to quick questions
		 * otherwise we get errors pre-token errors
		 */
		if (!this.$route.params.quickQuestions) {
			console.log(this.permissions);
			this.$router.push({
				name: 'quick-questions',
			});
		}

		this.loading = false;
	}

	private createAccount() {
		this.loading = true;
		this.form.email = this.form.email.toLowerCase();
		this.form.confirm_email = this.form.confirm_email.toLowerCase();
		this.error = '';

		this.form.phone_number = AuthService.phoneNumberCleanUp(this.form.phone_number);

		if (this.form.mobile_num !== '') {
			this.form.mobile_num = AuthService.phoneNumberCleanUp(this.form.mobile_num);
		}

		this.$v.$touch();
		if (this.$v.$invalid) {
			window.scrollTo(0, 0);
			return;
		}
		let attributes;
		if (this.form.mobile_num) {
			attributes = {
				phone_number: `+1${this.form.mobile_num}`,
				'custom:mfa_preference': this.form.mfaPreference,
				'custom:non_sms_number': `+1${this.form.phone_number}`,
			};
		} else {
			attributes = {
				phone_number: `+1${this.form.phone_number}`,
				'custom:mfa_preference': this.form.mfaPreference,
				'custom:non_sms_number': `+1${this.form.phone_number}`,
			};
		}
		// tslint:disable-next-line: prefer-const
		let user: ICognitoSignUpFields = {
			attributes,
			email: this.form.email,
			username: this.form.email,
			password: this.form.password,
		};

		if (
			process.env.VUE_APP_ENV_TYPE === 'production' ||
			process.env.VUE_APP_ENV_TYPE === 'test'
		) {
			user.attributes.name = this.form.given_name + ' ' + this.form.family_name;
		} else {
			user.attributes.given_name = this.form.given_name;
			user.attributes.family_name = this.form.family_name;
		}

		if (Brand.getBrand() === 'insurecareteams' && this.$store.state.Auth.brokerageId !== '') {
			user.attributes['custom:brokerageId'] = this.$store.state.Auth.brokerageId;
		}

		const authparams = {
			authenticationFlowType: 'USER_SRP_AUTH',
			clientMetadata: {
				policyNumber: this.riskResourcesRequested ? '' : JSON.stringify(this.policyNum),
				clientId: this.riskResourcesRequested ? '' : JSON.stringify(this.clientId),
				permissions: JSON.stringify(this.permissions),
				isUserInvited: JSON.stringify(this.isUserInvited),
				brand: Brand.getBrand(),
			},
		};
		console.log(authparams);

		this.$Amplify.Auth.configure(authparams);

		this.$Amplify.Auth.signUp(user)
			.then(data => {
				this.$emit('localUser', data.user);
				this.$emit('userCreds', user);
				if (data.userConfirmed === false) {
					this.$router.push({
						name: 'verify-email',
						params: {
							confirmSignUpConfig: {
								userCreds: user,
								username: data.user.username,
								mfaPreference: this.form.mfaPreference,
							},
						},
					});
				} else {
					this.$router.push({
						name: 'register-signup',
					});
				}
				this.loading = false;
			})
			.catch(e => {
				if (e.message === 'An account with the given email already exists.') {
					this.accountAlreadyExists = true;
				}
				this.setError(e);
				this.loading = false;
			});
	}

	private signIn() {
		this.$router.push({
			name: 'register-signup',
		});
	}

	private setError(e) {
		this.error = e.message || e;
		window.scrollTo(0, 0);
	}
}
